<template>
  <no-auth-layout class="confirm-email-page center-align">
    <div v-if="!data.success">
      <h2 class="card-title center-align">Weryfikacja adresu e-mail</h2>

      <div v-if="data.errors" class="center-align validation-errors">
        <p class="card-subtitle center-align red-text" v-if="data.errors['message']">
          {{ data.errors['message'].join(', ') }}
        </p>
        <p class="card-subtitle center-align red-text" v-if="data.errors['email']">
          {{ data.errors['email'].join(', ') }}
        </p>
        <p class="card-subtitle center-align red-text" v-else>
          Niestety nie udało nam się potwierdzić Twojego adresu email.
        </p>

        <a href="mailto:partnerzy@punkta.pl">
          <button class="btn-large z-depth-0">
            Napisz do nas
          </button>
        </a>
      </div>
      <p v-else class="card-subtitle center-align">
        Weryfikacja Twojego adresu e-mail w toku...
      </p>

      <br>
      <div class="card-footer">
        Jeśli potrzebujesz pomocy,<br/>
        wyślij email na <a href="mailto:partnerzy@punkta.pl"> partnerzy@punkta.pl </a>
      </div>
    </div>
    <div v-if="data.success">
      <h2 class="card-title center-align">Gratulacje!</h2>
      <p v-if="data.message" class="card-subtitle center-align">
        {{ data.message }}
      </p>
      <p v-else class="card-subtitle center-align">
        Twój e-mail został poprawnie zweryfikowany!
      </p>
      <br>
      <a @click="auth()">
        <button class="btn-large z-depth-0">
          Przejdź do aplikacji
        </button>
      </a>
      <div class="card-footer">
        Jeśli potrzebujesz pomocy,<br/>
        wyślij email na <a href="mailto:partnerzy@punkta.pl"> partnerzy@punkta.pl </a>
      </div>
    </div>
    <Loader :loading="data.loading"/>
  </no-auth-layout>
</template>

<script>
import NoAuthLayout from '@/layouts/noAuthLayout'
import Loader from '@/components/loader'
export default {
  name: 'confirmEmail',
  components: { NoAuthLayout, Loader },
  data () {
    return {
      data: {
        loading: false,
        success: false,
        message: '',
        errors: false
      }
    }
  },
  methods: {
    auth () {
      this.$store.dispatch('auth')
      .then(response => this.$router.push({ name: 'accountDetails' }))
    }
  },
  created () {
    this.data.loading = true
    this.$store.dispatch('confirmEmail', {
      confirmation_token: this.$route.query.confirmation_token
    })
    .then(
      response => {
        this.data.loading = false
        if (response.code === 200) {
          this.data.success = true
          this.data.message = response.data.message
        }
      },
      errorResponse => {
        this.data.loading = false
        this.data.errors = errorResponse.errors
      }
    )
  }
}
</script>



// WEBPACK FOOTER //
// confirmEmail.vue?46936a80